"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = reducer;
exports.destroyClientNote = exports.listClientNotes = exports.createClientNote = exports.ACTIONS = void 0;

var _URITemplate = _interopRequireDefault(require("urijs/src/URITemplate"));

var _lodash = require("lodash");

var _ = require(".");

var _spec = require("./spec");

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  pendingRequests: 0,
  data: {},
  errors: {},
  fieldErrors: {},
  nonFieldErrors: {},
  isLoading: false
};
var ACTIONS = {
  CREATE_CLIENT_NOTE: new _.APIAction('CREATE_CLIENT_NOTE'),
  LIST_CLIENT_NOTES: new _.APIAction('LIST_CLIENT_NOTES'),
  DESTROY_CLIENT_NOTE: new _.APIAction('DESTROY_CLIENT_NOTE')
};
exports.ACTIONS = ACTIONS;

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentPendingRequests;

  switch (action.type) {
    case ACTIONS.CREATE_CLIENT_NOTE.main:
      currentPendingRequests = state.pendingRequests + 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: {},
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case ACTIONS.LIST_CLIENT_NOTES.main:
      currentPendingRequests = state.pendingRequests + 1;
      var isGettingFirstPage = !action.payload.request.params.page ? true : false;
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: {},
        isGettingFirstPage: isGettingFirstPage,
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case ACTIONS.CREATE_CLIENT_NOTE.success:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, _defineProperty({}, action.payload.id, action.payload)),
        errors: {},
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case ACTIONS.LIST_CLIENT_NOTES.success:
      currentPendingRequests = state.pendingRequests - 1;
      var resultByKey = (0, _lodash.keyBy)(action.payload.results, 'id');
      var data = (0, _utils.isFirstPage)(action.payload) ? resultByKey : _objectSpread(_objectSpread({}, state.data), resultByKey);
      return _objectSpread(_objectSpread({}, state), {}, {
        data: data,
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case ACTIONS.DESTROY_CLIENT_NOTE.success:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        data: (0, _lodash.omit)(state.data, action.meta.object.id),
        errors: {},
        fieldErrors: {},
        nonFieldErrors: {},
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case ACTIONS.LIST_CLIENT_NOTES.fail:
    case ACTIONS.CREATE_CLIENT_NOTE.fail:
    case ACTIONS.DESTROY_CLIENT_NOTE.fail:
      currentPendingRequests = state.pendingRequests - 1;
      var splitedErrors = (0, _utils.splitErrors)(action.payload);
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: action.payload,
        fieldErrors: splitedErrors.fieldErrors,
        nonFieldErrors: splitedErrors.nonFieldErrors,
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    default:
      return state;
  }
}

var createClientNote = function createClientNote(data, clientID) {
  var endpoint = (0, _URITemplate["default"])(_spec.CLIENT_NOTES_ENDPOINT);
  var url = endpoint.expand({
    clientID: clientID
  });
  return {
    type: ACTIONS.CREATE_CLIENT_NOTE.main,
    payload: {
      request: {
        url: url,
        method: 'POST',
        data: data
      }
    },
    meta: {
      object: data
    }
  };
};

exports.createClientNote = createClientNote;

var listClientNotes = function listClientNotes(params, clientID) {
  var endpoint = (0, _URITemplate["default"])(_spec.CLIENT_NOTES_ENDPOINT);
  var url = endpoint.expand({
    clientID: clientID
  });
  return {
    type: ACTIONS.LIST_CLIENT_NOTES.main,
    payload: {
      request: {
        url: url,
        method: 'GET',
        params: params
      }
    }
  };
};

exports.listClientNotes = listClientNotes;

var destroyClientNote = function destroyClientNote(data, clientID) {
  var endpoint = (0, _URITemplate["default"])(_spec.CLIENT_NOTES_ENDPOINT);
  var url = endpoint.expand({
    clientID: clientID,
    id: data.id
  });
  return {
    type: ACTIONS.DESTROY_CLIENT_NOTE.main,
    payload: {
      request: {
        url: url,
        method: 'DELETE'
      }
    },
    meta: {
      object: data
    }
  };
};

exports.destroyClientNote = destroyClientNote;